export type Visibility = 'PERSONAL' | 'MUNICIPALITY' | 'PUBLIC';

export const VisibilityLabels: { [x in Visibility]: string } = {
  PERSONAL: '本人のみ',
  MUNICIPALITY: '自団体内に公開',
  PUBLIC: 'OS2autoproces全体に公開'
};

export const VisibilityKeys: { [x in Visibility]: x } = {
  PERSONAL: 'PERSONAL',
  MUNICIPALITY: 'MUNICIPALITY',
  PUBLIC: 'PUBLIC'
};

export const VisibilityOrder: Visibility[] = ['PERSONAL', 'MUNICIPALITY', 'PUBLIC'];
